module.exports = __webpack_public_path__ + "static/media/family.d92a580f.png";